export default __webpack_public_path__ + "src/images/packages/shipwreck-lodge/1b9da76f94c27702c602488e458d52b9-2.png";